import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface ShareProduct {
  name: string;
  url?: string;
  image_url: string;
  price?: number | null;
  currency?: string;
  store?: string;
}

export function useShareSuggestion() {
  const [isSharing, setIsSharing] = useState(false);

  const shareSuggestion = async (
    recipientIds: string[],
    product: ShareProduct,
    message?: string
  ) => {
    setIsSharing(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) throw new Error('Not authenticated');

      await Promise.all(
        recipientIds.map(async (recipientId) => {
          const response = await fetch(
            `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/share-product-suggestion`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${session.access_token}`,
              },
              body: JSON.stringify({
                recipient_id: recipientId,
                product,
                message,
              }),
            }
          );

          if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err.error || 'Failed to share');
          }
        })
      );

      // Shared silently
      return true;
    } catch (error) {
      console.error('Share suggestion error:', error);
      toast.error('Failed to share item');
      return false;
    } finally {
      setIsSharing(false);
    }
  };

  return { shareSuggestion, isSharing };
}
